import { type SupportedLocale } from '@zep-us/i18n';

import { type BoardTypeValue } from '@/shared/features/board/utils/boardTypeLabel';

import { resolveContentLocale } from './boardLandingLocale.const';

// ─── 이미지 ──────────────────────────────────────────────────────────────────

const ASSET_ROOT = '/assets/board-landing';

const SAMPLE_IMAGE_DIR: Record<BoardTypeValue, string> = {
  WALL: 'wall',
  GROUP: 'group',
  TIMELINE: 'timeline',
};

export function getHeroImage(locale: SupportedLocale): string {
  return `${ASSET_ROOT}/hero/${resolveContentLocale(locale)}.webp`;
}

export function getSampleImage(
  locale: SupportedLocale,
  boardType: BoardTypeValue,
): string {
  return `${ASSET_ROOT}/samples/${
    SAMPLE_IMAGE_DIR[boardType]
  }/${resolveContentLocale(locale)}.webp`;
}

export type FeatureImageKey = 'collab' | 'unlimited';

export function getFeatureImage(
  locale: SupportedLocale,
  key: FeatureImageKey,
): string {
  return `${ASSET_ROOT}/features/${key}/${resolveContentLocale(locale)}.webp`;
}

/** QR·기기 목업이라 텍스트가 없어 로케일 분기가 없다. */
export const FEATURE_QR_IMAGE = `${ASSET_ROOT}/features/qr.webp`;
export const INTRO_BOARD_IMAGE = `${ASSET_ROOT}/intro-board.webp`;
export const BOTTOM_CTA_IMAGE = `${ASSET_ROOT}/bottom-cta.webp`;

// ─── 레이아웃 ────────────────────────────────────────────────────────────────

/**
 * Intro·Stats·Samples·Features·Faq·BottomCta 6개 섹션이 공유하는 좌우·상하
 * padding. Hero 는 이 상수를 쓰지 않는다 — Figma 상 상단 64px·하단 80px 로
 * 비대칭이라(CTA 버튼과 이미지 사이 여백), 대칭인 이 상수를 씌우면 Hero
 * 쪽에 override 가 필요해져 오히려 더 지저분해진다.
 *
 * 모바일 상하 padding 이 40px 이 아닌 섹션(DQA #500 Samples 64px, #501
 * Features 56px)은 이 상수 앞에 base `pb-*`/`pt-*` 와 `min-[751px]:py-2xl` 를
 * 덧붙여 덮는다. longhand 가 shorthand(`py-2xl`) 뒤에 출력되므로 모바일에서만
 * 이기고, 751px 이상은 `min-[751px]:py-2xl` 로 이 상수 값(40px)이 복원된다.
 */
export const SECTION_PADDING =
  'px-[16px] py-2xl min-[751px]:px-[24px] min-[1025px]:px-[40px] min-[1025px]:py-3xl';
